import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getToken } from "../common/common";

const PrivateRoute = () => {
  const token = getToken();
  return token ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
